<template>
    <div class="contract">
        <div class="searchPart">
            <div style="display: flex; align-items: center">
                <el-input v-model="userName" placeholder="登录用户"></el-input>
                <el-button class="searchBtn" @click="search">搜索</el-button>
                <el-button type="text" class="resetBtn" @click="reset">
                    <i class="iconfont icon-qingchushujuku"></i>
                    <span>清除条件</span>
                </el-button>
            </div>
        </div>
        <div class="contractTable">
            <div class="tableTool">
                <div class="toolRight">
                    <el-button type="primary" size="small" :disabled="multipleSelection.length<1" @click="handleDelete"><i
                        class="el-icon-circle-plus-outline"></i>删除
                    </el-button>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                style="width: 100%"
                class="tableContent"
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    header-align="center"
                    align="center"
                    width="55">
                </el-table-column>
                <el-table-column
                    prop="userName"
                    label="登录用户"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="userIp"
                    label="操作地址"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
                <el-table-column
                    prop="createDate"
                    label="操作时间"
                    header-align="center"
                    align="center"
                    show-overflow-tooltip
                >
                </el-table-column>
            </el-table>
            <el-pagination
                class="pagination"
                background
                @current-change="handlePageChange"
                @prev-click="handleCurrentChange"
                @next-click="handleCurrentChange"
                :current-page="current"
                :page-size="pageSize"
                :total="total"
            >
            </el-pagination>
        </div>

    </div>
</template>

<script>
    import {systemLoginLogListByPage, deleteLoginLog} from "../../utils/interface";

    export default {
        name: "systemLoginLog",
        data() {
            return {
                current: 1,
                pageSize: 10,
                total: 0,
                userName: "",
                dialogVisible: false,
                tableData: [],
                form: {},
                multipleSelection:[],
            };
        },
        created() {
            this.search();
        },
        methods: {
            search() {
                this.tableData = [];
                this.form.userName = this.userName;
                this.form.current = this.current;
                this.form.pageSize = this.pageSize;
                systemLoginLogListByPage(this.form).then((res)=>{
                    console.log(res);
                    if(res != null && res.data != null && res.data.length > 0){
                        this.total = res.total;
                        this.tableData = res.data;
                    }else{
                        this.total = 0;
                    }
                });
            },
            reset() {
                this.userName = "";
                this.current = 1;
            },
            // 分页
            handleCurrentChange(val) {
                this.current = val;
            },
            handlePageChange(val) {
                this.current = val;
                this.search();
            },
            toDialog(val,data) {
                this.dialogVisible = true;
            },
            // 复选框选中值
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            handleDelete(){
                let uuidArr=[];
                this.multipleSelection.map((item) => {
                    uuidArr.push(item.uuid);
                });
                this.$confirm('确定要删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    deleteLoginLog(uuidArr).then((res)=>{
                        if(res.success){
                            this.$message({
                                type: 'success',
                                message: '删除成功!'
                            });
                            this.search();
                        } else {
                            this.$message({
                                type: 'waring',
                                message: res.message
                            });
                        }
                    });
                }).catch(() => {})
            },
        },
    };
</script>

<style lang="less" scoped>
    .searchPart {
        display: flex;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: center;

        /deep/ .el-input {
            width: initial;
            margin-bottom: 22px;
            margin-right: 30px;
        }

        /deep/ .el-input__inner {
            width: 242px;
            height: 35px;
            min-height: 35px;
            font-size: 12px;
            color: #999999;
            background-color: #f2f4f7;
            border: 1px solid #f2f4f7;
            border-radius: 5px;

            &:hover,
            &:focus {
                background-color: #fff;
                border: 1px solid #108ee9;
            }
        }

        /deep/ .el-input__prefix {
            top: -3px;
        }

        /deep/ .el-input__suffix {
            top: 2px;
        }

        /deep/ .el-button {
            display: block;
            line-height: 35px;
            padding: 0;
            height: 35px;
        }

        .searchBtn {
            width: 82px;
            background: #3d7fff;
            border: none;
            border-radius: 15px;
            font-size: 14px;
            color: #ffffff;
            margin-bottom: 22px;
        }

        .resetBtn {
            color: #333333;
            margin-bottom: 22px;
        }
    }

    .contract {
        padding: 20px;
        background: #fff;
        margin-left: 15px;

        .tableContent {
            min-height: 650px;
        }
    }

    .pagination {
        margin-top: 20px;
        text-align: right;
    }

    .dialogBox {
        .details {
            .detailsItem {
                padding-bottom: 20px;
                h3 {
                    font-weight: 700;
                    font-size: 16px;
                    color: #000;
                    margin-top: 0;
                    letter-spacing: 1px;
                    // border-bottom: 1px solid #ddd;
                    padding-bottom: 15px;
                }
                .itemContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    // padding: 0 30px;
                    .one-row {
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            // font-size: 14px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name {
                            // color: #000;
                            // font-size: 14px;
                            color: rgba(0, 0, 0, 0.65);
                        }
                    }
                    /deep/.nameimg  img{
                        width: 100%!important;
                    }


                    .two-row {
                        // width: 100%;
                        width: 50%;
                        margin-bottom: 22px;
                        display: flex;
                        font-size: 14px;
                        img{
                            width: 100%;
                        }
                        .label {
                            padding-right: 15px;
                            min-width: 95px;
                            color: rgba(0, 0, 0, 0.85);
                        }
                        .name {
                            // color: #000;
                            color: rgba(0, 0, 0, 0.65);
                            p{
                                width: 650px;
                            }

                        }
                    }
                }
                .itemPictureContent {
                    display: flex;
                    flex-wrap: wrap;
                    font-size: 15px;
                    padding: 0 30px;
                    justify-content: space-between;
                    .one-row {
                        width: 30%;
                        margin-bottom: 22px;
                        img {
                            width: 100%;
                            height: 138px;
                            border: 1px solid #ddd;
                        }
                        .name {
                            text-align: center;
                            padding-top: 10px;
                            font-size: 14px;
                            display: flex;
                            .label {
                                min-width: 80px;
                            }
                        }
                    }
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/logManage/systemLoginLog.vue